export type MetricsSpan = '5M' | '1H' | '6H' | '1D' | 'ALL'

/**
 * The windows the feeds offer.
 *
 * `ALL` is not among them on purpose. It asks for every trade a pair ever
 * had, which against a full mainnet stream is the slowest question on the
 * screen — and it was the default, so it was the first thing anybody waited
 * for. Speed is the product: a card that takes a second is a card nobody
 * saw. The span still exists as a bucket, because a pair's own page shows
 * its lifetime transaction count.
 */
export const STATS_PERIODS = ['5M', '1H', '6H', '1D'] as const
